export default "/images/type-bold.svg?32eebe762a9715b6fa79fa07777db331";